import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';
import { NavigationService, UrlService, WINDOW } from '@frontend/vanilla/core';

@Injectable({ providedIn: 'root' })
export class OutsideSportsGuard {
    private urlService = inject(UrlService);
    private navigationService = inject(NavigationService);
    private urlHelper = inject(UrlHelperService);

    private readonly _window = inject(WINDOW);

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const parsedUrl = this.urlService.parse(state.url);
        const absUrl = parsedUrl.absUrl();

        if (this._window.location.href === absUrl) {
            this.navigationService.goTo(this.urlHelper.getHomeUrl(), { replace: true });

            return false;
        }

        this.navigationService.goTo(parsedUrl, { forceReload: true });

        return false;
    }
}
